const initialState = () => ({
  paginatedReleaseNotes: undefined,
  loading: true
});

const releaseNotesState = initialState();

export { releaseNotesState };
